import { typeOption, typeBoolean } from '../constants/parameterTypes';
import { paramFormat, paramNoValidate } from '../constants/parameterNames';
import { compose, map, join } from 'ramda';

const formatMessage = 'message';
const formatFieldAndMessage = 'fieldAndMessage';

const description = "Provides a list of the form's current validation errors (if any) as a string value.";

const optionalParameters = {
    [paramFormat]: {
        description: `Format for the errors returned. Possible values are: ${formatMessage}, ${formatFieldAndMessage}. Defaults to ${formatMessage}.`,
        type: typeOption,
        options: [
            { name: 'Message', value: formatMessage },
            { name: 'Field and Message', value: formatFieldAndMessage },
        ],
    },
    [paramNoValidate]: {
        description: "(boolean, defaults to false) Prevents this command from re-validating the form's fields.",
        type: typeBoolean,
    },
};

// String -> ValidationError -> String
const formatError = (format) => ({ node, error }) => {
    switch (format) {
        case formatMessage:
            return error;
        case formatFieldAndMessage:
            return `${node.localName()} - ${error}`;
        default:
            throw new Error(`Invalid format value: ${format}`);
    }
};

// (String, [ValidationError]) -> String
const aggregateErrors = (format, errors) => compose(
    join('\n'),
    map(formatError(format)),
)(errors);

function GetErrors({ commonFunctions }) {
    const { getParamValue, getBoolParamValue } = commonFunctions;

    function execute({ validation }) {
        const noValidate = getBoolParamValue(paramNoValidate, false);
        const format = getParamValue(paramFormat, formatMessage);

        const errors = validation.getErrors(!noValidate);

        return aggregateErrors(format, errors);
    }

    return {
        description,
        optionalParameters,
        execute,
    };
}

export default GetErrors;